import 'primeicons/primeicons.css';
import 'primereact/resources/themes/mira/theme.css';
import 'primereact/resources/primereact.min.css';
import React, { useCallback, useEffect, useState } from 'react';
import Clock from './components/Clock';
import styled, { css } from 'styled-components';
import { ClockConfigType } from './config/letters/config.types';
import { SkinType } from './config/skins/skins.types';
import { SKINS } from './config/skins/skins.map';
import { useLocalStorage } from 'primereact/hooks';
import Settings from './components/Settings';
import { PrimeReactProvider } from 'primereact/api';
import { GlobalCss } from './styles/GlobalCss';
import useWindowHeight from './hooks/useWindowHeight';

const Wrapper = styled.div<{ $skin: SkinType; $mounted: boolean }>`
  width: 100vw;
  height: 100svh;
  position: relative;
  ${props => SKINS[props.$skin].wrapperSkin}
  transition: background-color 0.5s ease-out;

  ${props =>
    !props.$mounted &&
    css`
      display: none;
    `}
`;

function App() {
  const [mounted, mount] = useState(false);
  const [skin, setSkin] = useLocalStorage<SkinType>('aurora', 'skin');
  const [config, setConfig] = useLocalStorage<ClockConfigType>('german', 'config');
  const [isFullscreen, toggleIsFullscreen] = useLocalStorage(false, 'fullscreen');
  const [showSettings, toggleShowSettings] = useLocalStorage(true, 'showSettings');
  const windowHeight = useWindowHeight();

  const handleShowSettings = useCallback(() => toggleShowSettings(true), [toggleShowSettings]);
  const handleHideSettings = useCallback(() => toggleShowSettings(false), [toggleShowSettings]);

  useEffect(() => {
    // avoid flickering while getting localstorage values
    setTimeout(() => mount(true), 1000);
  }, []);

  return (
    <PrimeReactProvider>
      <Wrapper $skin={skin} $mounted={mounted}>
        <div role="button" onClick={handleShowSettings}>
          <Clock
            configType={config}
            skin={skin}
            size={windowHeight}
            isVisible={!showSettings}
            isFullscreen={isFullscreen}
          />
        </div>
        <Settings
          setConfig={setConfig}
          setSkin={setSkin}
          activeSkin={skin}
          activeConfig={config}
          isVisible={showSettings}
          size={windowHeight}
          onHide={handleHideSettings}
          isFullscreen={isFullscreen}
          setFullscreen={toggleIsFullscreen}
        />
      </Wrapper>
      <GlobalCss />
    </PrimeReactProvider>
  );
}

export default App;
